module.exports = __webpack_public_path__ + "img/objects-bg.669f6413.png";